var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-base search-container"},[_c('search-label-body',{attrs:{"label":_vm.label,"label-hidden":!_vm.label}},[_c('div',[_c('field-selector',{staticClass:"w-full xl:w-48",on:{"select":_vm.onChangeField},model:{value:(_vm.fieldId),callback:function ($$v) {_vm.fieldId=$$v},expression:"fieldId"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }